// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(/css/effectorGenes.css);"]);
// Module
exports.push([module.id, "\n", ""]);
// Exports
module.exports = exports;
